export default "__VITE_ASSET__Dre5maSo__"